import { SlideLoveCover } from './SlideLoveCover'
import { Slide01Title } from './Slide01Title'
import { SlideLifecycleTail } from './SlideLifecycleTail'
import { SlideMeetingPurpose } from './SlideMeetingPurpose'
import { SlideFormatByPhase } from './SlideFormatByPhase'
import { SlideValueCalculator } from './SlideValueCalculator'
import { SlideAgencyOfRecord } from './SlideAgencyOfRecord'
import { SlideSnakDefinition } from './SlideSnakDefinition'
import { SlideOperatingScale } from './SlideOperatingScale'
import { SlideCampaignFlowMockups } from './SlideCampaignFlowMockups'
import { Slide03Background } from './Slide03Background'
import { SlideMasterSnaks } from './SlideMasterSnaks'
import { SlideSnakExamples } from './SlideSnakExamples'
import { SlideGovernanceView } from './SlideGovernanceView'
import { SlideCountryBrandView } from './SlideCountryBrandView'
import { SlideCustomerJourneyExamples } from './SlideCustomerJourneyExamples'
import { SlideCampaignCostCalculator } from './SlideCampaignCostCalculator'

export const slides = [
  SlideLoveCover,
  SlideAgencyOfRecord,
  SlideMeetingPurpose,
  Slide01Title,
  SlideOperatingScale,
  SlideLifecycleTail,
  SlideFormatByPhase,
  SlideValueCalculator,
  SlideSnakDefinition,
  SlideSnakExamples,
  SlideCampaignFlowMockups,
  Slide03Background,
  SlideMasterSnaks,
  SlideGovernanceView,
  SlideCountryBrandView,
  SlideCustomerJourneyExamples,
  SlideCampaignCostCalculator,
]

export const slideTitles: { section: string; title: string }[] = [
  { section: 'Cover', title: 'All You Need Is Love' },
  { section: '02', title: 'Snak Agency of Record' },
  { section: '03', title: 'Purpose of Today’s Meeting' },
  { section: '04', title: 'Brand Campaign Strategy' },
  { section: '05', title: 'Built for Continued Campaigns' },
  { section: '06', title: 'Three Priorities Across the Product Lifecycle' },
  { section: '07', title: 'As Familiarity Grows, Format Shortens' },
  { section: '08', title: 'The Value of a 1% Improvement' },
  { section: '09', title: 'HCPs Don’t Lack Content. They Lack Time.' },
  { section: '10', title: 'What a Teaser Snak Looks Like in Practice' },
  { section: '11', title: 'Banner to Snak to Insight' },
  { section: '12', title: 'More Channels to Share' },
  { section: '13', title: 'Suggested Further Master Snaks' },
  { section: '14', title: 'One Governance View' },
  { section: '15', title: 'By Country and by Brand' },
  { section: '16', title: 'Snaks Throughout the Customer Journey' },
  { section: '17', title: 'Interactive Campaign Cost Calculator' },
]
